import { Box, createStyles, makeStyles } from '@material-ui/core'
import React from 'react'
import { Colors } from 'src/components/atoms'
import { AttachmentFile, DeleteCardProps } from '../type'
import { Card } from '../Card'
import { ImageCardContent } from './ImageCardContent'

export type ImageType = 'image'

export interface ImageCardProps {
  attachmentFile: AttachmentFile
  deleteProps: DeleteCardProps
}

const useStyles = makeStyles(() =>
  createStyles({
    linkBox: {
      display: 'block',
      padding: '8px',
      textDecoration: 'none',
      color: Colors.base.black,
      cursor: 'zoom-in'
    }
  })
)

export const ImageCard = ({ attachmentFile, deleteProps }: ImageCardProps) => {
  const classes = useStyles()

  return (
    <Card deleteProps={deleteProps}>
      {deleteProps.isDeletable ? (
        <Box p="8px">
          <ImageCardContent attachmentFile={attachmentFile} isEditing />
        </Box>
      ) : (
        <Box
          className={classes.linkBox}
          onClick={() => {
            window.open(attachmentFile.url!, '_blank')
          }}
        >
          <ImageCardContent attachmentFile={attachmentFile} />
        </Box>
      )}
    </Card>
  )
}
